module.exports = __webpack_public_path__ + "d5339c102fd9812ec21e7bfba1dc9013.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RoundedMplus1c-Thin.ttf
// module id = 24
// module chunks = 0